<template>
  <Container :class="$style.container">
    <div>
      <HeadingMedium>
        {{ name }}
      </HeadingMedium>
      <div :class="$style.subheader">
        <Icon
          icon="clock"
          inline
        />
        <ParagraphBody :class="$style.inline">
          Estimated implementation time
        </ParagraphBody>
      </div>
      <div :class="$style.timelinesContainer">
        <span
          v-for="(duration, size) in timelines"
          :key="size"
          :class="$style.timeline"
        >
          {{ size }}: <strong>{{ duration }}</strong>
        </span>
      </div>
    </div>
    <div :class="$style.body">
      <div
        v-for="phase, index in phases"
        :key="phase.name"
        data-test-id="ImplementationGuide_phase"
      >
        <HeadingExtraSmall>
          Phase {{ getNumberString(index) }}: {{ phase.name }}
        </HeadingExtraSmall>
        <ParagraphBody>
          <ul :class="$style.list">
            <li
              v-for="step in phase.steps"
              :key="step"
              data-test-id="ImplementationGuide_step"
            >
              {{ step }}
            </li>
          </ul>
        </ParagraphBody>
      </div>
    </div>
    <div>
      <Button
        text="View Full Guide"
        @click="handleViewFullGuide"
      />
    </div>
  </Container>
</template>
<script>
import {
  Button,
  Container,
  HeadingExtraSmall,
  HeadingMedium,
  Icon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ImplementationGuideConstants from 'client/Pricing/ImplementationGuides/ImplementationGuideConstants';
import Util from 'client/util/Util';

const {
  fullImplementationLink,
  implementationTimelines,
} = ImplementationGuideConstants;

const {
  description,
  location,
  text,
  section,
  toUrl,
} = eventProperties;

const {
  implementationGuidesPage,
} = eventLocations;

export default {
  name: 'ImplementationGuide',

  EventHelper,
  Util,

  components: {
    Button,
    Container,
    HeadingExtraSmall,
    HeadingMedium,
    Icon,
    ParagraphBody,
  },

  props: {
    name: {
      required: true,
      type: String,
    },
    phases: {
      required: true,
      type: Array,
    },
    shortTimeline: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    timelines() {
      return this.shortTimeline ? implementationTimelines.short
        : implementationTimelines.long;
    },
  },

  methods: {
    getNumberString(index) {
      switch (index) {
        case 0: return 'One';
        case 1: return 'Two';
        case 2: return 'Three';
        case 3: return 'Four';
        case 4: return 'Five';
        case 5: return 'Six';
        case 6: return 'Seven';
        case 7: return 'Eight';
        default: return index + 1;
      }
    },

    handleViewFullGuide() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'open implementation guide kb',
        [location]: implementationGuidesPage,
        [section]: this.name,
        [text]: 'View Full Guide',
        [toUrl]: fullImplementationLink,
      });
      this.$options.Util.openUrl(fullImplementationLink);
    },
  },
};
</script>
<style scoped module>
.body {
  margin: 3rem 0;
}

.container {
  background: var(--jcWhite300);
  border: var(--jc-border);
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
}

.inline {
  display: inline;
}

.list {
  padding: 0 0 var(--jc-spacer) var(--jc-spacer);
}

.subheader {
  margin: var(--jc-spacer) 0;
}

.timeline {
  background: var(--jc-color-informational-active);
  margin-bottom: var(--jc-spacer-small);
  margin-right: var(--jc-spacer-small);
  padding: var(--jc-spacer-small);
}

.timelinesContainer {
  display: flex;
  flex-wrap: wrap;
}
</style>
